<template>
  <div class="navbar yld-framework-navbar">
    <div class="left-menu">
      <template v-if="isDayu">
        <search-order />
      </template>
    </div>
    <div class="right-menu">
      <div>
        <template v-if="isDayu">
          <el-badge
            class="navbar-download-log"
            @click.native="showWarning"
          >
            预警推送设置
          </el-badge>
          <el-badge 
            class="navbar-download-log"
            @click.native="goToDownload"
          >下载记录</el-badge>
          </template>
      </div>
      <!-- 用户信息 -->
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="hover">
        <div class="avatar-wrapper">
          <el-avatar class="user-avatar" shape="circle" :size="40" fit="fill" :src="avatar || defaultHeadUrl" alt="用户头像">
          </el-avatar>
          <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
          <span>{{ userName }}</span>
        </div>
        <el-dropdown-menu slot="dropdown" class="yld-dropdown-menu">
          <div>
            <el-dropdown-item v-if="isDayu" @click.native="company" style="padding-right: 0;">
              <div class="user-company">
                <div class="avatat-container">
                  <el-avatar class="user-avatar" shape="circle" :size="40" fit="fill" :src="avatar || 'https://yldfiles.geekyum.com/fe/imgs/def_logo.png'" alt="用户头像" />
                </div>
                <div class="company-info">
                  <div class="company-name">{{ tenantSummary.branchName }}</div>
                  <!-- <div class="company-status">
                    <span @click.stop="visibleCertification= true">企业认证</span>
                    <span @click.stop="visibleEnterprise = true">加入企业</span>
                  </div> -->
                  <div class="validity">有效期至：{{ tenantSummary.validEnd || '-' }}</div>
                </div>
                <div class="xiangyou-icon">
                  <yun-icon name="icon-xiangyou" />
                </div>
              </div>
            </el-dropdown-item>
            <el-dropdown-item @click.native="personal">
              <yun-icon name="icon-renwu" />
              <span>个人设置</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="emptyCache">
              <yun-icon name="icon-shuaxin" />
              <span>清空缓存</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <yun-icon name="icon-dengchu" />
              <span>退出</span>
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    <yun-drawer-form
      custom-class="yujing-drawer-form"
      title="预警推送设置"
      :visible="visible"
      :append-to-body="true"
      :btn-loading="btnLoading"
      @confirm="confirm"
      @cancel="cancel"
      @open="getEarlyWarningPush"
    >
      <div class="yujing-tips">
        <yun-icon name="icon-tishi1" />
        <span>目前仅支持上海和宁波的消息推送，将通过企业微信进行推送</span>
      </div>
      <div v-for="(item,index) in warningTitle" :key="index">
        <div class="yujingt-title">{{ item.title }}</div>
        <warning-check
          :push-data="item.data"
          :warningType="item.ids"
          :noChangeId="noChangeId"
          @changeIds="changeIds"
        />
      </div>
    </yun-drawer-form>
    <!-- 申请认证 -->
    <!-- <Certification :visible.sync="visibleCertification" :cellPhone="cellPhone" @onJoinEnterprise="onJoinEnterprise" /> -->
    <!-- 申请加入企业 -->
    <!-- <Enterprise :visible.sync="visibleEnterprise" :cellPhone="cellPhone" @onCertification="onCertification" /> -->
    <!-- 基础信息 -->
    <!-- <BasicInfo :visible.sync="visibleBasinfo" /> -->
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BASE_URL } from '@yld/yun-utils-host'
import SearchOrder from './SearchOrder/index.vue'
import YunDrawerForm from '@yld/yun-drawer-form'
import yunMoment from '@yld/yun-utils-moment'
import { getOrderEarlyWarningPush, saveOrderEarlyWarningPushNew } from  '../../../api/earlyWarning'
import WarningCheck from './warningCheck'
import { Storage } from '@yld/yun-utils-common'

export default {
  components: {
    SearchOrder,
    YunDrawerForm,
    WarningCheck,
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'userinfo',
      'menu_list',
      'tenantId'
    ]),
    userName() {
      return this.userinfo.aliasName || this.userinfo.realName
    },
    // 默认头像
    defaultHeadUrl() {
      // 全球捷运 定制
      if(this.tenantId && this.tenantId === '578644382409543680'){
        return 'https://yldfiles.geekyum.com/fe/imgs/worldex_head.png'
      } else if(this.tenantId && this.tenantId === '626474597625761792'){
        // 冠亚定制
        return 'https://yldfiles.geekyum.com/fe/imgs/topasia_head.png'
      } else {
        return 'https://yldfiles.geekyum.com/fe/imgs/def_logo1.png'
      }
    }
  },
  mounted() {
    // 租户信息
    this.getTenantSummary()
  },
  data() {
    return {
      tenantSummary: {
        validEnd: '',
        branchId: '',
        branchName: ''
      },
      visible: false,
      warningTitle: [
        {
          title: '异常推送',
          ids: 'warningPushTagIds',
          data: []
        },
        {
          title: '推送渠道',
          ids: 'pushChannelTypeVOs',
          data: []
        },
      ],
      btnLoading: false,
      warningPush: [], // 异常推送
      ChannelTypePush: [], // 推送渠道
      pushChannelTypeVOs: [],
      warningPushTagIds: [],
      noChangeId:false,
      // 是否有大羽权限
      isDayu:false
      // visibleEnterprise: false,
      // visibleCertification: false,
      // visibleBasinfo:false
    }
  },
  methods: {
    company() {
      if (this.$appId === '90006') {
        const path = this.$route.path
        if (path !== '/90006/branchdetails') {
          this.$router.push('/90006/branchdetails/' + this.tenantSummary.branchId)
        }
      } else {
        window.location.replace(BASE_URL.HOME_WORK+'/90006/branchdetails/' + this.tenantSummary.branchId)
      }
    },
    getTenantSummary() {
      this.$store.dispatch('user/getTenantSummaryInfo').then(response => {
      if(response){
        if(response.appList && response.appList.length > 0){
            const appValid = response.appList.find(item => item.appId === 1)
            if(appValid && appValid.validEnd){
              this.tenantSummary.validEnd = yunMoment(appValid.validEnd).format('YYYY-MM-DD')
            }
            if(appValid){
              this.isDayu = true
            }
          }
          this.tenantSummary.branchId = response.branchId
          this.tenantSummary.branchName = response.branchName
      }
    }).catch(()=>{
      this.tenantSummary = {}
    })
    },
    cancel() {
      this.visible = false
      this.pushChannelTypeVOs = []
      this.warningPushTagIds = []
      this.warningTitle[0].data = []
      this.warningTitle[1].data = []
    },
    confirm() {
      const params = {
        exceptionPushTypes: this.warningPushTagIds,
        pushChannelTypes: this.pushChannelTypeVOs
      }
      this.btnLoading = true
      if(this.warningPushTagIds.length !== 0 && this.pushChannelTypeVOs.length === 0 ){
         this.$message.error('请选择推送渠道');
         this.btnLoading = false
      } else {
        saveOrderEarlyWarningPushNew(params).then(res => {
        if (res.success) {
          this.cancel()
        }
          this.btnLoading = false
      })
      }
      
    },
    changeIds(val) {
      if (val.type == 'warningPushTagIds') {
        this.warningPushTagIds = val.data

      } if (val.type == 'pushChannelTypeVOs') {
        this.pushChannelTypeVOs = val.data
      } 
      if(val.type == 'warningPushTagIds' && val.data.length === 0 ){
        this.noChangeId = true
      } else if(val.type == 'warningPushTagIds' && val.data.length !== 0 ) {
        this.noChangeId = false
      }
    },
    showWarning() {
      this.visible = true
    },
    getEarlyWarningPush() {
      const loading = this.$loading({
        target: '.yujing-drawer-form'
      })
      getOrderEarlyWarningPush().then(res => {
        loading.close()
        const {data} = res
        if(data){
          this.warningTitle[0].data = data.exceptionPushTypeVOs
          this.warningTitle[1].data = data.pushChannelTypeVOs
        }
      }).catch(()=>{
        loading.close()
      })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      Storage.clearStorage()
      await this.$store.dispatch('user/logout')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      window.location.replace(BASE_URL.YLD_PASSPORT + '?redirect=' + encodeURIComponent(window.location.href))
    },
    // 个人中心
    personal(){
      if (this.$appId === '90002') {
        const path = this.$route.path
        if (path !== '/90002/personal') {
          this.$router.push('/90002/personal')
        }
      } else {
        window.location.replace(BASE_URL.HOME_WORK+'/90002/personal')
      }
    },
    // 前往文件下载
    goToDownload() {
      if (this.$appId === '90010') {
        const path = this.$route.path
        if (path !== '/90010/filedownload') {
          this.$router.push('/90010/filedownload')
        }
      } else {
        window.location.replace(BASE_URL.HOME_WORK+'/90010/filedownload')
      }
    },
    // 清空缓存
    emptyCache(){
      Storage.clearStorage()
      location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.yld-framework-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left-menu {
    margin-left: 12px;
  }
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;

    .navbar-download-log {
      margin-left: 16px;
      cursor: pointer;
      color: #333333;
      font-size: 14px;
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 16px;
      margin-left: 16px;

      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 100%;
          margin-right: 8px;
        }

        span {
          font-size: 16px;
          color: #333333;
        }
      }
    }
  }
}
.yujing-drawer-form {
  .warning-message {
    background: var(--geek-color-primary);
  }
  .yujing-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    line-height:22px;
    color: #E59840;
    background-color: #fdf6ec;
    border-radius: 5px;
    svg {
      margin-left:10px;
      margin-right: 5px;
    }
  }
  .yujingt-title {
    margin: 6px 0;
    padding-left: 5px;
    border-left: 3px solid var(--geek-color-primary);
    font-size: 14px;
    font-weight: 600;
    line-height:14px;
  }
}
</style>
<style lang="scss">
  .yld-dropdown-menu {
    margin: 0 !important;
    padding: 0 !important;
    .el-dropdown-menu__item {
      //padding: 12px 24px !important;
      line-height: 35px;
      margin: 0;
      svg {
        margin-right: 8px;
      }
    }
    .user-company {
        padding: 6px 0;
        display:flex;
        justify-content: space-between;
        .avatat-container {
          display: flex;
          align-items: center;
          padding-right: 15px;
        }
        .company-info {
          .company-name {
            font-size: 16px;
            line-height: 23px;
          }
          .validity {
            color: var(--geek-color-primary);
            font-size: 13px;
            line-height: 26px;
          }
          .company-status {
            span {
              display: inline-block;
              background-color: var(--geek-color-primary);
              margin-right: 10px;
              font-weight: 400;
              font-size: 12px;
              color: #fff;
              line-height:24px;
              border-radius: 2px;
              padding: 0 6px;
            }
          }
        }
        .xiangyou-icon {
          display: flex;
          align-items: center;
          padding-left: 5px;
        }
      }
    .el-dropdown-menu__item--divided:before {
      content: none
    }
    .el-dropdown-menu__item.el-dropdown-menu__item--divided {
      margin: 0 !important;
    }
  }
  .yujing-drawer-form{
    .el-drawer__body .yun-drawer-form-scroll {
      padding-top: 3px !important
    }
  }
</style>
